<template>
    <div class="sign-contract" v-loading="pageLoading">
        <div class="content-box first">
            <el-descriptions :column="1" :title="contractDetail.contractAfterAdminName ? '签署个人账号升级为企业账号合同' : '签署企业授权合同'">
                <el-descriptions-item label="合同主要概要">
                    <template v-if="contractDetail.contractAfterAdminName">
                        将原个人授权代理合同
                        <span class="important">({{ contractDetail.contractBeforeAdminName }})</span>
                        的授权歌曲，通过企业
                        <span class="important">({{ contractDetail.contractAfterAdminName }})</span>
                        进行授权代理， 授权权利不变；专辑歌曲授权期限三年，到期后如果未通知，将会自动续约； 版税将会结算至您设置的企业收款账号
                    </template>
                    <template v-else>专辑歌曲授权期限三年，到期后如果未通知，将会自动续约；版税将会结算至您设置的收款账号</template>
                </el-descriptions-item>
                <el-descriptions-item label="授权地区">全球</el-descriptions-item>
                <el-descriptions-item label="授权权利">详见合同</el-descriptions-item>
            </el-descriptions>
            <iframe :src="contractDetail.contractFileFullPath"></iframe>
            <div class="page-btn-box">
                <el-button @click="$router.go(-1)">暂不签署</el-button>
                <el-button type="primary" @click="dialogVisible = true">开始签署</el-button>
            </div>
        </div>
        <el-dialog title="签署合同" append-to-body :visible.sync="dialogVisible" width="450px" center>
            <div class="contract-body">
                <el-alert
                    v-if="smsTime !== 0"
                    :title="`您尾号为${phone}的手机将会收到认证服务商“电子牵”的认证短信验证码，请填写验证码以进行电子身份认证`"
                    :closable="false"
                    type="warning"
                    show-icon
                ></el-alert>
                <div class="item">
                    <label>手机号：</label>
                    <div class="cont">
                        <el-input placeholder="手机号码" disabled v-model="telephone"></el-input>
                    </div>
                </div>
                <div class="item">
                    <label>验证码：</label>
                    <div class="cont">
                        <el-input placeholder="验证码" v-model="smsCode">
                            <el-button @click="sendSms" slot="append">
                                {{ smsTime === 0 ? '获取验证码' : `( ${smsTime}s )` }}
                            </el-button>
                        </el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="signContract()">确认签署</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {getEnterpriseContract, sendEnterpriseContract, getEnterpriseContractSms} from '@/api/user';
export default {
    data() {
        return {
            pageLoading: false,
            dialogVisible: false,
            contractDetail: {},
            serialNumber: '',
            smsTime: 0,
            smsCode: '',
            telephone: '',
            signContractLoading: false,
        };
    },
    computed: {
        phone() {
            const {telephone} = this.$store.state.userInfo || {};
            return telephone ? telephone.slice(-4) : '';
        },
    },
    mounted() {
        const {telephone} = this.$store.state.userInfo || {};
        if (telephone) this.telephone = telephone;
        this.getContract();
    },
    methods: {
        // 获取签署验证码
        async sendSms() {
            if (this.smsTime > 0) return;
            const response = await getEnterpriseContractSms(this.contractDetail.letSignContractCode);
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            this.serialNumber = result.serialNumber;
            this.smsTime = 60;
            const smsInterval = setInterval(() => {
                this.smsTime -= 1;
                if (this.smsTime <= 0) clearInterval(smsInterval);
            }, 1000);
        },
        // 签署合同
        async signContract() {
            if (!this.smsCode) return this.$message.error('请填写短信验证码');
            if (!this.serialNumber) return this.$message.error('您还未获取验证码');
            if (this.signContractLoading) return;
            this.signContractLoading = true;
            const {smsCode, serialNumber} = this;
            const {letSignContractCode} = this.contractDetail;
            const response = await sendEnterpriseContract(letSignContractCode, serialNumber, smsCode);
            const {state, msg} = response.data;
            this.signContractLoading = false;
            if (!state) return this.$message.error(msg || '抱歉，签署失败，请确认输入的短信验证码是否正确');
            this.dialogVisible = false;
            await this.$store.dispatch('getUserInfo'); // 更新用户信息
            this.$router.push({path: `/manage/accountManage`});
        },
        // 获取合同
        async getContract() {
            this.pageLoading = true;
            const respnose = await getEnterpriseContract();
            const {state, msg, result} = respnose.data;
            this.pageLoading = false;
            if (!state) return this.$message.error(msg || '获取数据失败,请重试');
            this.contractDetail = result;
        },
    },
};
</script>
<style lang="scss">
.sign-contract {
    overflow: hidden;
    border-radius: 0px 0px 6px 6px;

    .content-box {
        padding: 50px 40px;
    }

    .el-descriptions-item__label {
        width: 125px;
    }

    .el-descriptions-item__content {
        flex: 1;
        display: block;
    }

    iframe {
        border: none;
        width: 100%;
        height: 500px;
        margin-top: 40px;
    }
}

.contract-body {
    .item {
        display: flex;
        margin-top: 10px;

        label {
            width: 60px;
            line-height: 40px;
        }

        .cont {
            flex: 1;
            display: flex;
        }
    }
}
</style>
